module.exports = __webpack_public_path__ + "static/media/error.8c91fde6.svg";